package team.platforma.aicombo.activity.main.component.library.fragment

import team.platforma.extra_nav.component.fragment_component.Fragment

object LibraryFragment : Fragment(
    route = "library_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->

    }
)